
import moment from "moment-business-days";
import constants from "../constants";
import dateUtils from "../dateUtils";
import errorMessageFilter from "../filters/errorMessageFilter";
import h from "./h";
import userDeptRoleViewService from "./userDeptRoleViewService";

import VueCookies from 'vue-cookies';

export default {
  initPageableParams(pagable) {

    !pagable && (pagable = { page: 0, size: 10000 });
    !pagable.size && (pagable.size = 10000);
    return pagable;
  },
  merge(object1, object2) {
    let object3 = {};

    object1 &&

      Object.keys(object1).forEach(key => (object3[key] = object1[key]));

    object2 &&

      Object.keys(object2).forEach(key => (object3[key] = object2[key]));

    return object3;
  },

  filterCategoryData(data, status, includeIds) {
    return h.findAll(
      data,
      item =>
        item.status === status ||
        item.status == null ||
        (includeIds && includeIds.indexOf(item.id) !== -1)
    );
  },

  nvl(object, valueWhenFalse) {
    return object || valueWhenFalse;
  },

  buildShortName(fullName) {
    if (!fullName) return "";
    fullName = this.replaceVietnameseCharacters(fullName);
    return h
      .collect((" " + (fullName || "")).match(/(\s)[a-zA-Z]/g), item =>
        item.trim()
      )
      .join("")
      .toUpperCase();
  },

  duyetTree(node, getChildNodesFn, before, after) {
    before && before(node);
    h.each(getChildNodesFn(node), childNode =>
      this.duyetTree(childNode, getChildNodesFn, before, after)
    );
    after && after(node);
  },

  validatePhoneFormat(value) {
    if (!value) return false;
    value = value.trim().replace(/\s+/g, "");

    let regex = /^\+?(0|84)?\d{9,10}$/;
    return regex.test(value);
  },

  validateEmailFormat(value, callbackFnWhenFalse) {
    let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(value.toLowerCase());
  },

  replaceVietnameseCharacters(alias) {
    let str = alias;
    str = str.toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    // str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
    // str = str.replace(/ + /g, " ");
    str = str.trim();
    return str;
  },
  checkDeviceIsMobile() {
    // return true;
    return this.checkDeviceIsIos() || this.checkDeviceIsAndroid();
  },

  checkDeviceIsAndroid() {
    // return false;
    let userAgent = navigator.userAgent;
    let isMobile =
      h.find(
        ["android"],
        item => userAgent.toLowerCase().indexOf(item) !== -1
      ) != null;
    return isMobile;
  },

  checkDeviceIsIos() {
    // return true;
    let userAgent = navigator.userAgent;
    let isMobile =
      h.find(
        ["ipad", "iphone"],
        item => userAgent.toLowerCase().indexOf(item) !== -1
      ) != null;
    return isMobile;
  },

  like(sentence, phrase) {
    if (!sentence || !sentence.trim()) return false;
    if (!phrase || !phrase.trim()) return true;
    sentence = sentence.trim().toLowerCase();
    phrase = phrase.trim().toLowerCase();
    let words = phrase.split(/\s+/);
    let likeRegex = words.join(".*");
    return new RegExp(likeRegex).test(sentence);
  },

  compareUserDeptRoleView(userDeptRole1, userDeptRole2) {
    if (userDeptRole1.roleCode !== userDeptRole2.roleCode)
      if (userDeptRole1.roleCode === constants.ROLE.CODE.LANH_DAO) return -1;
      else if (userDeptRole2.roleCode === constants.ROLE.CODE.LANH_DAO)
        return 1;
    if (userDeptRole1.positionOrder !== userDeptRole2.positionOrder)
      return userDeptRole1.positionOrder > userDeptRole2.positionOrder ? 1 : -1;
    if (userDeptRole1.firstName !== userDeptRole2.firstName)
      return (userDeptRole1.firstName || "").localeCompare(
        userDeptRole2.firstName || ""
      );
    return (userDeptRole1.fullName || "").localeCompare(
      userDeptRole2.fullName || ""
    );
  },

  compareDepartment(department1, department2) {
    // console.log('Start compareDepartment ...')
    // console.log('department1.orderNumber:', department1.orderNumber)
    // console.log('department2.orderNumber:', department2.orderNumber)
    let result = (department1.orderNumber || 10000) - (department2.orderNumber || 10000);
    // console.log('(department1.orderNumber || 1) - (department2.orderNumber || 1):', result);
    if (result === 0) {
      result = (department1.deptName || "").localeCompare(
        department2.deptName || ""
      );
    }
    return result;
  },

  compareList(docRelationA, docRelationB){
    if(!docRelationB && !docRelationA){
      return false;
    }
    if(docRelationA.length !== docRelationB.length)
    {
      return true;
    }
    else {
      for(let i = 0; i < docRelationA.length; i ++)
      {
        if(docRelationA[i].id !== docRelationB[i].id){
          return true;
        }
        else {
          if(docRelationA[i].objectRelateToId !== docRelationB[i].objectRelateToId ||
            docRelationA[i].docCode !== docRelationB[i].docCode ||
            docRelationA[i].quote !== docRelationB[i].quote ||
            docRelationA[i].docDate !== docRelationB[i].docDate ||
            docRelationA[i].objectTypeRelateTo !== docRelationB[i].objectTypeRelateTo ||
            docRelationA[i].relationType !== docRelationB[i].relationType ||
            docRelationA[i].attachedType !== docRelationB[i].attachedType ||
            docRelationA[i].docContentType !== docRelationB[i].docContentType ||
            docRelationA[i].checkedSignCA !== docRelationB[i].checkedSignCA)
          {
            return true;
          }
        }
      }
      return false;
    }
  },

  serialize(obj) {
    let str = [];
    for (let p in obj)
      if (obj.hasOwnProperty(p) && obj[p] != null && obj[p] !== undefined) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  },

  exportReport(reportUrl, query) {
    let baseServiceURL = constants.BASE_SERVICE_URL;
    // console.log(`${baseServiceURL}${reportUrl}?${this.serialize(query)}`);
    let query1 = this.merge(query,{tenantCode: VueCookies.get(constants.HTTP_HEADER_KEY.X_TENANT_CODE)}, );
    window.open(

      `${baseServiceURL}${reportUrl}?${this.serialize(query1)}`,
      "_blank "
    );
  },

  isUserDeptRoleMatchWithQuery(userDeptRole, query, globalDeptRole) {
    return (
      this.like(userDeptRole.fullName, query) ||
      this.like(userDeptRole.userName, query) ||
      this.like(userDeptRole.email, query) ||
      this.like(userDeptRole.mobile, query) ||
      this.like(userDeptRole.deptName, query) ||

      (userDeptRole.deptCode === globalDeptRole &&
        userDeptRole.roleCode === constants.ROLE.CODE.LANH_DAO &&
        this.like("Ban tổng giám đốc", query)) ||
      this.like(userDeptRole.deptCode, query) ||
      this.like(userDeptRole.roleName, query) ||
      this.like(userDeptRole.positionName, query)
    );
  },

  standardlizePhoneNumber(value) {
    value = value.trim().replace(/\s+/g, "");
    if (value.length === 9) return "+84" + value;
    if (value.startsWith("0")) return "+84" + value.substring(1);
    if (value.startsWith("84")) return "+84" + value.substring(2);
    if (!value.startsWith("+84")) return "+84" + value;
    return value;
  },

  getDefaultDateQuickFilterOption() {
    return {

      shortcuts: h.collect(
        [
          constants.DATE_QUICK_FILTER.CODE.HOM_NAY,
          constants.DATE_QUICK_FILTER.CODE.TUAN_NAY,
          constants.DATE_QUICK_FILTER.CODE.NAM_NAY,
          constants.DATE_QUICK_FILTER.CODE.LAST_WEEK,
          constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS,
          constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
        ],
        item => this.buildDateQuickFilterOption(item)
      )
    };
  },

  getDateQuickFilterOptionForSearchTdhvp() {
    return {
      shortcuts: h.collect([2019, 2018, 2017, 2016, 2015, 2014, 2013], year => {
        return {
          text: year !== 2013 ? `Năm ${year}` : " 2000 - 2013",
          onClick(picker) {
            picker.$emit(
              "pick",
              year !== 2013
                ? dateUtils.getRangeOfYear(year, year)
                : dateUtils.getRangeOfYear(2000, 2013)
            );
          }
        };
      })
    };
  },

  isErrorResponseMatch(error, httpStatus, errorMessage) {
    return (
      error &&
      error.response &&
      error.response.data &&
      error.response.data.httpStatus === httpStatus &&
      (!errorMessage || error.response.data.error === errorMessage)
    );
  },

  isBussinessErrorException(error) {
    return this.isErrorResponseMatch(
      error,
      constants.HTTP_STATUS.BAD_REQUEST,
      "BusinessErrorException"
    );
  },

  getFileExt(file) {
    let fileName = file ? file.name : "";
    return fileName.indexOf(".") !== -1
      ? file.name

          .split(".")
          .pop()
          .toLowerCase()
      : "";
  },

  filterUserDeptRoleView(query, userDeptRole) {
    return this.isUserDeptRoleMatchWithQuery(userDeptRole, query);
  },

  groupActors(actors, filters) {
    let groups = [];
    // console.log(actors)
    // console.log(filters)
    let actors_ = (actors || []).slice();

    for (let index = 0; index < actors_.length; ) {
      let actor = actors_[index];
      let filter = h.find(filters, filter_ => filter_.isMatch(actor));
      if (filter) {
        let actorsInGroup = h.findAll(actors_, actor_ =>
          filter.isMatch(actor_)
        );
        if (filter.isFullOfGroups(actorsInGroup)) {
          //neu da full user trong 1 nhom > gop lai thanh 1 nhom;

          groups.push({ type: "group", data: actorsInGroup, filter: filter });
          h.each(actorsInGroup, actor_ =>
            actors_.splice(actors_.indexOf(actor_), 1)
          ); //loai bo actor trong danh sach cu;
        } else {

          groups.push({ type: "item", data: actor });
          index++; //next item;
        }
      } else {

        groups.push({ type: "item", data: actor });
        index++; //next item;
      }
    }
    return groups;
  },

  formatCurrency(value) {
    return value.toLocaleString("vi-VN", {
      style: "currency",
      currency: "VND"
    });
  },

  initGroupFilters(getUserDeptRoleIdFn) {
    return Promise.all(
      h.collect(
        [constants.ACTOR_GROUPS.BANTGD, constants.ACTOR_GROUPS.HDTV, constants.ACTOR_GROUPS.BANTVDU],
        actorGroup =>
          userDeptRoleViewService
            .findAllByActorGroup(actorGroup)
            .then(response => {
              return {
                actorGroup: actorGroup,
                actorsInGroups: response.data
              };
            })
      )
    ).then(results => {
      return h.collect(results, result => {
        return {
          actorGroup: result.actorGroup,
          actorsInGroups: result.actorsInGroups,
          isMatch(actor) {
            return (
              actor &&
              h.exists(
                this.actorsInGroups,
                actor_ => actor_.id === getUserDeptRoleIdFn(actor)
              )
            );
          },
          isFullOfGroups(actorsInGroup) {
            return (
              actorsInGroup &&
              actorsInGroup.length &&
              this.actorsInGroups &&
              this.actorsInGroups.length &&
              actorsInGroup.length ===

                (this.actorsInGroups ? this.actorsInGroups.length : 0)
            );
          }
        };
      });
    });
  },

  initGroupFiltersVinataba(getUserDeptRoleIdFn) {
    return Promise.all(
      h.collect(
        [constants.ACTOR_GROUPS.LANHDAO_TCT],
        actorGroup =>
          userDeptRoleViewService
            .findAllByActorGroup(actorGroup)
            .then(response => {
              return {
                actorGroup: actorGroup,
                actorsInGroups: response.data
              };
            })
      )
    ).then(results => {
      return h.collect(results, result => {
        return {
          actorGroup: constants.ACTOR_GROUPS.LANHDAO_TCT,
          actorsInGroups: result.actorsInGroups,
          isMatch(actor) {
            return (
              actor &&
              h.exists(
                this.actorsInGroups,
                actor_ => actor_.id === getUserDeptRoleIdFn(actor)
              )
            );
          },
          isFullOfGroups(actorsInGroup) {
            return (
              actorsInGroup &&
              actorsInGroup.length &&
              this.actorsInGroups &&
              this.actorsInGroups.length &&
              actorsInGroup.length ===

              (this.actorsInGroups ? this.actorsInGroups.length : 0)
            );
          }
        };
      });
    });
  },

  /**
   * hiển thị tên group danh sách người;
   * @param filter
   * @returns {string}
   */
  getLabelForActorGroupFilter(filter) {
    switch (filter.actorGroup) {
      case constants.ACTOR_GROUPS.HDTV:
        return "Hội đồng thành viên";
      case constants.ACTOR_GROUPS.BANTGD:
        return "Ban Tổng Giám đốc";
      case constants.ACTOR_GROUPS.BANTVDU:
        return "Ban Thường vụ";
      case constants.ACTOR_GROUPS.LANHDAO_TCT:
        return "Lãnh đạo TCT";
      default:
        return "-";
    }
  },
  /**
   * hiển thị tên group danh sách người;
   * @param filter
   * @returns {string}
   */
  getLabelForActorGroupFilterVinataba(filter) {
    switch (filter.actorGroup) {
      case constants.ACTOR_GROUPS.HDTV:
        return "Hội đồng thành viên";
      case constants.ACTOR_GROUPS.BANTGD:
        return "Ban Tổng Giám đốc";
      case constants.ACTOR_GROUPS.BANTVDU:
        return "Ban Thường vụ";
      case constants.ACTOR_GROUPS.LANHDAO_TCT:
        return "Lãnh đạo TCT";
      default:
        return "-";
    }
  },

  getNodeLabelForHandlersTree(node) {
    let nodeType = node.nodeType;
    switch (nodeType) {
      case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
        return node.department.deptName || "-";
      case constants.DEPARTMENT_TREE.NODE_TYPE.BTGD:
        return "Ban Tổng giám đốc";
      case constants.DEPARTMENT_TREE.NODE_TYPE.HDTV:
        return "Hội đồng thành viên";
      case constants.DEPARTMENT_TREE.NODE_TYPE.DVTT:
        return "Đơn vị trực thuộc";
      case constants.DEPARTMENT_TREE.NODE_TYPE.PBCN:
        return "Phòng ban chức năng";
      case constants.DEPARTMENT_TREE.NODE_TYPE.PBCNAndDVTT:
        return "Phòng ban CN & Đơn vị TT";
      case constants.DEPARTMENT_TREE.NODE_TYPE.CUSTOM:
        return "Lãnh đạo Ủy ban";
      default:
        return "-";
    }
  },


  getNodeLabelForHandlersTreeVinataba(node) {
    let nodeType = node.nodeType;
    switch (nodeType) {
      case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
        return node.department.deptName || "-";
      case constants.DEPARTMENT_TREE.NODE_TYPE.LANHDAO_TCT:
        return "Lãnh đạo TCT";
      case constants.DEPARTMENT_TREE.NODE_TYPE.HDTV:
        return "Hội đồng thành viên";
      case constants.DEPARTMENT_TREE.NODE_TYPE.DVTT:
        return "Đơn vị trực thuộc";
      case constants.DEPARTMENT_TREE.NODE_TYPE.PBCN:
        return "Phòng ban chức năng";
      case constants.DEPARTMENT_TREE.NODE_TYPE.PBCNAndDVTT:
        return "Phòng ban CN & Đơn vị TT";
      default:
        return "-";
    }
  },

  initMeetingTypeOptions() {
    return [
      {
        id: constants.HC_CASE_CALENDAR.MEETING_TYPE.ONLINE,
        label: errorMessageFilter({
          errorCode: "hcCaseCalendar.meetingType.online.label"
        })
      },
      {
        id: constants.HC_CASE_CALENDAR.MEETING_TYPE.OFFLINE,
        label: errorMessageFilter({
          errorCode: "hcCaseCalendar.meetingType.offline.label"
        })
      }
    ];
  },

  convertPageableToSubmit(pageable) {
    return {
      page: pageable.page,
      size: pageable.size,
      sort: [pageable.sort, pageable.order].join(",")
    };
  },

  buildDateQuickFilterOption(code) {
    let text;

    switch (code) {
      case constants.DATE_QUICK_FILTER.CODE.HOM_NAY:
        text = "Hôm nay";
        break;
      case constants.DATE_QUICK_FILTER.CODE.TUAN_NAY:
        text = "Tuần này";
        break;
      case constants.DATE_QUICK_FILTER.CODE.NAM_NAY:
        text = "Năm nay";
        break;
      case constants.DATE_QUICK_FILTER.CODE.LAST_WEEK:
        text = "1 tuần trước";
        break;
      case constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS:
        text = "1 tháng trước";
        break;
      case constants.DATE_QUICK_FILTER.CODE.LAST_YEAR:
        text = "1 năm trước";
        break;
      case constants.DATE_QUICK_FILTER.CODE.THIS_MONTH:
      case constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2:
        text = "Tháng này";
        break;
      case constants.DATE_QUICK_FILTER.CODE.LAST_MONTH:
        text = "Tháng trước";
        break;
      case constants.DATE_QUICK_FILTER.CODE.LAST_YEAR_2:
        text = "Năm ngoái";
        break;
      case constants.DATE_QUICK_FILTER.CODE.TO_TRINH_QUA_HAN_DEFAULT_RANGE:
        text = "5 - 10 ngày trước";
        break;
      default:
        return null;
    }

    return {
      text: text,
      onClick(picker) {
        picker.$emit("pick", dateUtils.getDatesByQuickFilter(code));
      }
    };
  },

  getShortString(str, option) {
    if (!str) return str;
    let maxLength = option.maxLength;
    if (!maxLength) return str;
    if (str.length > maxLength) {
      str = str.substring(0, maxLength - 3) + "...";
    }
    return str;
  },

  /**
   * build node label cho cho select-handler-tree
   * @param node
   * @returns {string|*|string}
   */
  getNodeLabel(node) {
    let nodeType = node.nodeType;
    switch (nodeType) {
      case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
        return node.department.deptName || "-";
      case constants.DEPARTMENT_TREE.NODE_TYPE.BTGD:
        return "Ban Tổng giám đốc";
      case constants.DEPARTMENT_TREE.NODE_TYPE.HDTV:
        return "Hội đồng thành viên";
      case constants.DEPARTMENT_TREE.NODE_TYPE.DVTT:
        return "Đơn vị trực thuộc";
      case constants.DEPARTMENT_TREE.NODE_TYPE.PBCN:
        return "Phòng ban chức năng";
      case constants.DEPARTMENT_TREE.NODE_TYPE.PBCNAndDVTT:
        return "Phòng ban CN & Đơn vị TT";
      case constants.DEPARTMENT_TREE.NODE_TYPE.CUSTOM:
        return "Lãnh đạo Ủy Ban";
      default:
        return "-";
    }
  },

  getProcessTypeLabel(processType) {
    switch (processType) {
      case constants.PROCESS_TYPE.CHUTRI:
        return "Chủ trì";
      case constants.PROCESS_TYPE.PHOIHOP:
        return "Phối hợp";
      case constants.PROCESS_TYPE.NHANDEBIET:
        return "Nhận để biết";
      default:
        return "-";
    }
  },

  getDocProcessStatusLabel(status) {
    switch (status) {
      case constants.INCOMING_PROCESS_STATUS.DA_XU_LY:
        return "Đã xử lý";
      case constants.INCOMING_PROCESS_STATUS.CHO_XU_LY:
        return "Chờ xử lý";
      case constants.INCOMING_PROCESS_STATUS.DANG_XU_LY:
        return "Đang xử lý";
      case constants.INCOMING_PROCESS_STATUS.DUNG_HAN:
        return "Đúng hạn";
      case constants.INCOMING_PROCESS_STATUS.QUA_HAN:
        return "Quá hạn";
      case constants.INCOMING_PROCESS_STATUS.TRONG_HAN:
        return "Trong hạn";
      default:
        return "-";
    }
  },

  initTimeRange(from, to) {
    return from || to
      ? [dateUtils.toMoment(from), dateUtils.toMoment(to)]
      : null;
  },

  timeRangeChanged(docDateRange, fn_) {
    fn_(
      docDateRange && docDateRange[0] ? docDateRange[0].getTime() : undefined,
      docDateRange && docDateRange[1] ? docDateRange[1].getTime() : undefined
    );
  },

  buildUserDeptRoleViewLabel(userDeptRoleView) {
    return userDeptRoleView
      ? `${userDeptRoleView.fullName} (${userDeptRoleView.positionName} ${
          userDeptRoleView.deptName
        })`
      : null;
  },

  idDiffWithArray(arr1, arr2) {
    !arr1 && (arr1 = []);
    !arr2 && (arr2 = []);
    return (
      arr1.length !== arr2.length ||
      h.exists(arr1, item1 => arr2.indexOf(item1) === -1)
    );
  },

  getIntParamsFromQuery(query, property) {
    return query[property] ? parseInt(query[property]) : undefined;
  },

  getParamFromQuery(query, property) {
    return query[property] || undefined;
  },

  getArrayParamFromQuery(query, property) {
    let param = query[property];
    if (!param) return undefined;
    return Array.isArray(param) ? param : [param];
  },

  convertDateToQueryParams(date) {
    return date ? date.getTime() : undefined;
  },

  buildEmailValidationRule() {
    return (rule, value, callback) => {
      if (!value) return callback();

      if (!this.validateEmailFormat(value.toLowerCase()))
        return callback(new Error("Định dạng email không đúng"));

      if (!value.toLowerCase().endsWith("@mobifone.vn"))
        return callback(
          new Error("Email đăng ký phải là email của MobiFone (@mobifone.vn)")
        );

      return callback();
    };
  },

  buildPhoneValidationRule() {
    return (rule, value, callback) => {
      if (!value) return callback();
      if (!this.validatePhoneFormat(value))
        return callback(new Error("Định dạng số điện thoại không đúng"));
      else return callback();
    };
  },

  buildRequiredValidationConstrains() {
    return {
      required: true,
      message: "Trường dữ liệu bắt buộc",
      trigger: "blur"
    };
  },

  getFirstName(fullName) {
    if (fullName && fullName.trim()) {
      fullName = fullName.trim().replaceAll(/\s+/g, " ");
      let array = fullName.split(" ");
      return array[array.length - 1];
    }
    return "";
  },

  getStatusLabel(status) {
    switch (status) {
      case constants.STATUS_.ACTIVE:
        return "Hoạt động";
      case constants.STATUS_.DEACTIVE:
        return "Không hoạt động";
      default:
        return "";
    }
  },

  validateFormCommon(formElement, $message) {
    return new Promise(resolve => {
      formElement.validate(valid => {
        if (!valid) {
          $message.error("Có lỗi nhập liệu. Vui lòng kiểm tra lại");
        } else {
          resolve();
        }
      });
    });
  },

  formatDateForDisplayActionLog(value) {
    return value
      ? new moment(new Date(value)).format(constants.DEFAULT_DATE_FORMAT)
      : null;
  },

  confirm($confirm, message) {
    return $confirm(message, "Thông báo", {
      confirmButtonText: "Xác nhận",
      cancelButtonText: "Hủy",
      type: "warning"
    });
  },

  convertTableSortEvent({ column, prop, order }) {
    return {
      sort: prop,
      order:
        order === "ascending" ? "asc" : order === "descending" ? "desc" : null
    };
  },

  convertToTableSortEvent({ sort, order }) {
    return {
      prop: sort,
      order:
        order === "asc" ? "ascending" : order === "desc" ? "descending" : null
    };
  },

  isFirstStep(vbStep) {
    return (
      vbStep &&
      (vbStep.posType === constants.STEP_POS_TYPE.BAT_DAU ||
        vbStep.posType === constants.STEP_POS_TYPE.BOTH)
    );
  },

  initMobileSignerNetworkOptions() {
    return h.collect(
      [
        constants.USERS.MOBILE_SIGNER_NETWORK.VINAPHONE_CA,
        constants.USERS.MOBILE_SIGNER_NETWORK.VIETTEL_CA,
        constants.USERS.MOBILE_SIGNER_NETWORK.MOBIFONE_CA,
        // constants.USERS.MOBILE_SIGNER_NETWORK.MOBIFONE_CA_ToKen,
        constants.USERS.MOBILE_SIGNER_NETWORK.BAN_CO_YEU_CA
      ],
      networkCode => {
        return {
          value: networkCode,
          label: this.getNetworkCodeLabel(networkCode)
        };
      }
    );
  },

  initMobileSignerNetworkOptionsUsb() {
    return h.collect(
      [
        constants.USERS.MOBILE_SIGNER_NETWORK_USB.MOBIFONE_CA_ToKen,
      ],
      networkCode => {
        return {
          value: networkCode,
          label: this.getNetworkCodeLabelUsb(networkCode)
        };
      }
    );
  },

  getNetworkCodeLabel(networkCode) {
    switch (networkCode) {
      case constants.USERS.MOBILE_SIGNER_NETWORK.VINAPHONE_CA:
        return errorMessageFilter({ errorCode: "users.networkCode.vinaphoneCa" });
      case constants.USERS.MOBILE_SIGNER_NETWORK.VIETTEL_CA:
        return errorMessageFilter({ errorCode: "users.networkCode.ViettelCA" });
      case constants.USERS.MOBILE_SIGNER_NETWORK.MOBIFONE_CA:
        return errorMessageFilter({ errorCode: "users.networkCode.mobiCa" });
      // case constants.USERS.MOBILE_SIGNER_NETWORK.MOBIFONE_CA_ToKen:
      //   return errorMessageFilter({ errorCode: "users.networkCode.token_mobiCa" });
      case constants.USERS.MOBILE_SIGNER_NETWORK.BAN_CO_YEU_CA:
        return errorMessageFilter({ errorCode: "users.networkCode.banCycp" });
      default:
        return "";
    }
  },

  getNetworkCodeLabelUsb(networkCode) {
    switch (networkCode) {
      case constants.USERS.MOBILE_SIGNER_NETWORK_USB.MOBIFONE_CA_ToKen:
        return errorMessageFilter({ errorCode: "users.networkCode.token_mobiCa" });
      default:
        return "";
    }
  },

  initCaProviderOptions() {
    return h.collect(
      [
        constants.DEPARTMENT.CA_PROVIDER.MOBI_CA,
        constants.DEPARTMENT.CA_PROVIDER.BAN_CYCP
      ],
      caProvider => {
        return {
          value: caProvider,
          label: this.getCaProviderLabel(caProvider)
        };
      }
    );
  },

  getCaProviderLabel(caProvider) {
    switch (caProvider) {
      case constants.DEPARTMENT.CA_PROVIDER.MOBI_CA:
        return errorMessageFilter({
          errorCode: "department.caProvider.mobiCa"
        });
      case constants.DEPARTMENT.CA_PROVIDER.BAN_CYCP:
        return errorMessageFilter({
          errorCode: "department.caProvider.banCycp"
        });
      default:
        return "";
    }
  },
  convertDateTime(inputDate){
    return errorMessageFilter({
        errorCode: "signToken.docDate",
        params: [
          inputDate.get("date") < 10 ? "0".concat(inputDate.get("date").toString()) : inputDate.get("date"),
          inputDate.get("month") + 1 < 3 ? "0".concat((inputDate.get("month") + 1).toString()) : inputDate.get("month") + 1,
          inputDate.get("year")
        ]
      })
  },
};



// WEBPACK FOOTER //
// ./src/services/utils.js